// L/C Tracking API actions follow the Sales Vuex state/getters/mutations/actions pattern.
import Axios from 'axios';
import { lcTrackingUrl, lcTrackingPublicUrl } from '@/store/api';
const publicApi = Axios.create();
// 01. Server-backed workspace state.
const initialMeta = () => ({
  user: { id: null, name: '' },
  owners: [],
  permissions: {},
  today: '',
  branch_id: null,
});
const state = {
  meta: initialMeta(),
  cases: [],
  sources: [],
  summary: { total: 0, attention: [], shipments: [], tasks: [] },
};
const getters = {
  getLcTrackingMeta: (state) => state.meta,
  getLcTrackingCases: (state) => state.cases,
  getLcTrackingSources: (state) => state.sources,
  getLcTrackingSummary: (state) => state.summary,
};
// 02. State updates; request sequencing stays with the calling composable.
const mutations = {
  SET_LC_TRACKING_META(state, value) {
    state.meta = value;
  },
  SET_LC_TRACKING_CASES(state, value) {
    state.cases = value;
  },
  SET_LC_TRACKING_SOURCES(state, value) {
    state.sources = value;
  },
  SET_LC_TRACKING_SUMMARY(state, value) {
    state.summary = value;
  },
  RESET_LC_TRACKING(state) {
    state.meta = initialMeta();
    state.cases = [];
    state.sources = [];
    state.summary = { total: 0, attention: [], shipments: [], tasks: [] };
  },
};
// 03. Existing authenticated/public endpoints, returned as normal Axios responses.
const actions = {
  async getLcTrackingMeta({ commit }) {
    const response = await Axios.get(lcTrackingUrl + '/meta');
    commit('SET_LC_TRACKING_META', response.data.data);
    return response;
  },
  async getLcTrackingDashboard({ commit }) {
    const response = await Axios.get(lcTrackingUrl + '/dashboard');
    commit('SET_LC_TRACKING_SUMMARY', response.data.data);
    return response;
  },
  getLcTrackingCases(_, params) {
    return Axios.get(lcTrackingUrl + '/cases', { params });
  },
  getLcTrackingSources(_, params) {
    return Axios.get(lcTrackingUrl + '/sources', { params });
  },
  getLcTrackingSourceLcs(_, params) {
    return Axios.get(lcTrackingUrl + '/source-lcs', { params });
  },
  getLcTrackingCase(_, id) {
    return Axios.get(lcTrackingUrl + '/cases/' + id);
  },
  createLcTrackingCase(_, data) {
    return Axios.post(lcTrackingUrl + '/cases', data);
  },
  updateLcTrackingCase(_, { id, data }) {
    return Axios.put(lcTrackingUrl + '/cases/' + id, data);
  },
  saveLcTrackingAction(_, { id, path, data, method = 'post' }) {
    return Axios({ method, url: lcTrackingUrl + '/cases/' + id + '/' + path, data });
  },
  uploadLcTrackingDocument(_, { id, data }) {
    return Axios.post(lcTrackingUrl + '/cases/' + id + '/documents', data);
  },
  getLcTrackingDocument(_, { id, document }) {
    return Axios.get(lcTrackingUrl + '/cases/' + id + '/documents/' + document, {
      responseType: 'blob',
    });
  },
  saveLcTrackingLink(_, { id, data }) {
    return Axios.post(lcTrackingUrl + '/cases/' + id + '/link', data);
  },
  exportLcTracking(_, { filter, signal }) {
    return Axios.get(lcTrackingUrl + '/export', {
      params: { filter },
      responseType: 'blob',
      signal,
    });
  },
  getPublicLcTracking(_, token) {
    return publicApi.get(lcTrackingPublicUrl + '/' + encodeURIComponent(token));
  },
  getPublicLcTrackingDocument(_, { token, document }) {
    return publicApi.get(
      lcTrackingPublicUrl + '/' + encodeURIComponent(token) + '/documents/' + document,
      { responseType: 'blob' },
    );
  },
};
export default { state, getters, mutations, actions };
